import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { Window } from "@progress/kendo-react-dialogs";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import DavetliKatilimciService from "../../services/srv-davetli/DavetliKatilimciService";
import { FormInput } from "../../components/sys-form/FormComponents";
import {
  emailValidator,
  requiredValidator,
} from "../../components/sys-form/FormValidators";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";

export const QrManualCheckIn = (props) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (dataItem) => {
    const { isValid, values } = dataItem;
    if (!isValid || submitting) return;

    // Event comes from parent props, not form values.
    if (!props.event?.davetlI_ETKINLIK_TANIM_ID) {
      return;
    }

    if (!values.email && !values.telefon) {
      defaultAlertMessages.MessageDetailError = t("phone_or_email_required");
      confirmAlert({
        customUI: ({ onClose }) => {
          return getConfirmErrorMessage(onClose, defaultAlertMessages);
        },
      });
      return;
    }

    setSubmitting(true);
    try {
      const scanResult = await DavetliKatilimciService.manualCheckIn({
        DAVETLI_ETKINLIK_TANIM_ID: props.event.davetlI_ETKINLIK_TANIM_ID,
        AD: values.ad,
        SOYAD: values.soyad,
        TELEFON: values.telefon || null,
        EMAIL: values.email || null,
      });
      props.onAdded?.(scanResult);
    } catch {
      // error alert already shown by service; keep dialog open for retry
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"65vh"}
      initialWidth={"35%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      {!props.event?.davetlI_ETKINLIK_TANIM_ID ? (
        <p>{t("select_guest_event_first")}</p>
      ) : (
        <Form
          onSubmitClick={onSubmit}
          render={(formRenderProps) => (
            <div style={{ width: "90%", margin: "0 auto" }}>
              <FormElement>
                <Field
                  name="ad"
                  label={t("name")}
                  component={FormInput}
                  validator={(value) => requiredValidator(value, t)}
                />
                <Field
                  name="soyad"
                  label={t("surname")}
                  component={FormInput}
                  validator={(value) => requiredValidator(value, t)}
                />
                <Field name="telefon" label={t("phone")} component={FormInput} />
                <Field
                  name="email"
                  label={t("email")}
                  component={FormInput}
                  validator={(value) =>
                    value ? emailValidator(value, t) : ""
                  }
                />
                <div className="k-form-buttons">
                  <Button disabled={!formRenderProps.allowSubmit || submitting}>
                    {submitting ? t("saving") : t("save")}
                  </Button>
                </div>
              </FormElement>
            </div>
          )}
        />
      )}
    </Window>
  );
};
